import { sortBy, prop } from 'ramda'

export const sortSeasons = sortBy(prop('season'))

export const sortEpisodes = sortBy(prop('episode'))
